import calendarSettingsStyles from "../../../styles/calendarSettings.module.css";

type CellAlignment = "Left" | "Middle";

const RowCell = ({
  children,
  width,
  alignment,
}: {
  children: React.ReactNode;
  width?: number | string;
  alignment?: CellAlignment;
}) => {
  return (
    <div
      className={calendarSettingsStyles.tableRowCell}
      style={{
        width: width,
        minWidth: width,
        justifyContent: alignment === "Middle" ? "center" : "flex-start",
      }}
    >
      {children}
    </div>
  );
};

export default RowCell;
